import React from "react";
import { EXTERNAL_URLS } from "../../../constants/support";

interface ContactLinkProps {
  /**
   * Custom text to display. Defaults to "contact us"
   */
  children?: React.ReactNode;
  /**
   * Additional CSS classes
   */
  className?: string;
}

export const ContactLink = ({
  children = "contact us",
  className = "underline",
}: ContactLinkProps) => {
  return (
    <a
      href={EXTERNAL_URLS.CONTACT_US}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};